import { render, staticRenderFns } from "./IndicatorDisplay.vue?vue&type=template&id=4013100c&scoped=true&"
import script from "./IndicatorDisplay.vue?vue&type=script&lang=js&"
export * from "./IndicatorDisplay.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorDisplay.vue?vue&type=style&index=0&id=4013100c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4013100c",
  null
  
)

export default component.exports